import { put, takeLatest } from "@redux-saga/core/effects";
import {
  Bucket,
  CoreJsonMeta,
  FetchPaginatedModelsAction,
  GenericMap,
  GET_PAGINATED_MODELS,
  SearchDefinition,
  NewModelAction,
  CREATE_NEW_MODEL,
} from "./types";
import {
  populateStoreWithBuckets,
  populateStoreWithPaginatedModels,
  getCurrentModels,
} from "./actions";
import { Model } from "types";
import {
  CoreJsonResponse,
  genFetch,
  IRequestObject,
  reqHandler,
  RequestType,
  withToken,
} from "coral-utility";
import { models } from "state/api/models";
import { authenticatedFailureAction } from "../connect/actions";
const queryString = require("query-string");

function* getPaginatedModels(action: FetchPaginatedModelsAction) {
  try {
    const { payload } = action;
    const searchDef: SearchDefinition = JSON.parse(JSON.stringify(payload));
    delete searchDef["searchText"];
    delete searchDef["filters"];
    const url = queryString.stringify(searchDef, {
      skipEmptyString: true,
    });
    const searchRequest: IRequestObject = {
      onFetch: () =>
        genFetch(models.search(url, payload.searchText, payload.filters))(
          withToken()
        )(),
      onSuccess: (response: CoreJsonResponse<Model[], CoreJsonMeta>) =>
        put(populateStoreWithPaginatedModels(response)),
      onFailure: () => put(authenticatedFailureAction()),
      onDeserialize: "json",
      type: RequestType.ONE,
    };

    const bucketRequest: IRequestObject = {
      onFetch: () =>
        genFetch(models.getBuckets(payload.searchText))(withToken())(),
      onSuccess: (response: CoreJsonResponse<GenericMap<Bucket[]>, null>) =>
        put(populateStoreWithBuckets(response)),
      onFailure: () => put(authenticatedFailureAction()),
      onDeserialize: "json",
      type: RequestType.ONE,
    };

    yield reqHandler(searchRequest);
    yield reqHandler(bucketRequest);
  } catch (error) {
    console.error(error);
  }
}

function* createNewModel(action: NewModelAction) {
  try {
    const { payload } = action;
    const createNewRequest: IRequestObject = {
      onFetch: () => genFetch(models.new(payload))(withToken({}))(),
      onSuccess: () => put(getCurrentModels()),
      onFailure: () => put(authenticatedFailureAction()),
      onDeserialize: "json",
      type: RequestType.ONE,
    };
    yield reqHandler(createNewRequest);
  } catch (error) {
    console.error(error);
  }
}

export default function* connectSaga() {
  yield takeLatest(GET_PAGINATED_MODELS, getPaginatedModels);
  yield takeLatest(CREATE_NEW_MODEL, createNewModel);
}
